// global.BaseUrl = "https://foodweb-seahorse.ksoftpl.com/seahorse/public/api";
// global.AssetsUrl = "https://foodweb-seahorse.ksoftpl.com/seahorse/public";
global.BaseUrl = "https://admin.foodweb-seahorse.ksoftpl.com/api";
global.AssetsUrl = "https://admin.foodweb-seahorse.ksoftpl.com";
